export const duckName = 'dashboard'
